module.exports = {
  canvasAnimation () {
    animateDiv()

    function makeNewPosition () {
      var container = document.getElementById('canvas')
      var h = container.offsetHeight - 100
      var w = container.offsetWidth - 100
      var nh = Math.floor(Math.random() * h)
      var nw = Math.floor(Math.random() * w)
      return [nh, nw]
    }

    function offset (target) {
      var rect = document.getElementById(target).getBoundingClientRect()
      var bodyElt = document.body
      return {
        top: rect.top + bodyElt.scrollTop,
        left: rect.left + bodyElt.scrollLeft
      }
    }

    function animateDiv () {
      document.getElementById('canvas').classList.add('functionActive')
      var letters = document.getElementsByClassName('draggable')
      var container = document.getElementById('canvas')

      for (var i = 0; i < letters.length; i++) {
        var newq = makeNewPosition(container)
        var oldq = offset(letters[i].id)
        var position = [oldq.top, oldq.left]
        var speed = calcSpeed(position, newq)

        window.Velocity(letters[i], { top: newq[0], left: newq[1] }, { duration: speed,
          easing: [ 0.215, 0.61, 0.355, 1 ],
          complete: function () {
           // animateDiv()
          }
        })
      }
    }

    function calcSpeed (prev, next) {
      var speed = ((Math.floor(Math.random() * 4) + 3) * 1450)
      return speed
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/canvasAnimation.js